import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        // User is not Authenticated. User said YES and wants to create an account
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: 'executeUserWantsRegistrationDecision',
        title: "__create_comparehub_account__",
        fields: [
            {
                // label: '',
                name: 'wants_to_create_account',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                "choices": [
                    { "text": "__opt_yes__", "value": "yes" },
                    { "text": "__opt_not_right_now__", "value": "no" }
                ]
            },
        ],
        textTop: "__create_comparehub_account_benefits__",
        textBottom: "__create_comparehub_account_opt_in__",
        hideButtonsSection: true,
        isStepSkippable: false
    },
];

export default steps;
